
import { defineComponent } from 'vue';
import { OioCascader } from '@kunlun/vue-ui-antd';

export default defineComponent({
  name: 'AreaSelect',
  components: {
    OioCascader
  },
  props: ['areaList', 'areaOptions', 'onChange'],
  setup(props) {
    return {};
  }
});
